import { EditorState, Modifier } from "draft-js";
import React from "react";
import { getCurrentEntity, hasEntity } from "../../utils";
import { ToolbarItemGroup } from "../ToolbarItemGroup";
import { ToolbarItem } from "../ToolbarItem";

export const InsertSymbolEdit = ({ editorState, onChange, setEditingEntity }) => {
    const entityType = "INSERT_SYMBOL";

    const currentEntity = hasEntity(editorState, entityType) ? getCurrentEntity(editorState) : null;

    const handleAddSymbol = (symbol) => {
        const currentContent = editorState.getCurrentContent();
        const currentSelection = editorState.getSelection();
        const newContent = Modifier.replaceText(currentContent, currentSelection, symbol);
        const newEditorState = EditorState.push(editorState, newContent, "insert-characters");
        setEditingEntity(currentEntity);
        onChange(newEditorState);
    };

    const onClose = event => {
        event.preventDefault();
        event.stopPropagation();
        setEditingEntity(null);
    }

    return (
        <ToolbarItemGroup>
            <ToolbarItem label={"©"} onToggle={() => handleAddSymbol("©")} />
            <ToolbarItem label={"€"} onToggle={() => handleAddSymbol("€")} />
            <ToolbarItem label={"–"} onToggle={() => handleAddSymbol("–")} />
            <button onMouseDown={onClose} style={{padding: "0 6px"}}>Lukk</button>
        </ToolbarItemGroup>
    );
};
